/* Renders the localStorage wishlist on /pages/favorite without an app. */
(function () {
  'use strict';

  var SVG_NS = 'http://www.w3.org/2000/svg';

  function productUrl(handle) {
    return window.Shopify.routes.root + 'products/' + encodeURIComponent(handle) + '.js';
  }

  /* Same shape as the 'heart' case in snippets/icon.liquid. */
  function heartIcon() {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', 'icon icon--heart');
    svg.setAttribute('width', '16');
    svg.setAttribute('height', '16');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.6');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');

    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', 'M12 20s-7-4.6-7-9.4A3.9 3.9 0 0112 8a3.9 3.9 0 017 2.6c0 4.8-7 9.4-7 9.4z');
    svg.appendChild(path);
    return svg;
  }

  function formatPrice(cents) {
    if (window.Diente && typeof window.Diente.formatAmount === 'function') {
      return window.Diente.formatAmount(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function card(product) {
    var element = document.createElement('article');
    element.className = 'card';

    var link = document.createElement('a');
    link.href = product.url;
    link.className = 'card__media card__media-link';

    var image = document.createElement('img');
    image.className = 'card__image';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.src = product.featured_image || '';
    image.alt = product.title;
    link.appendChild(image);

    /* .card__wish is absolutely positioned against .card__media, so it has to
       live inside the media element — appending it to the card put the heart
       in the page's top-left corner. */
    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'card__wish';
    remove.setAttribute('data-wishlist-toggle', '');
    remove.setAttribute('data-wishlist-handle', product.handle);
    remove.setAttribute('aria-pressed', 'true');
    remove.setAttribute('aria-label', 'Șterge din favorite');
    remove.appendChild(heartIcon());
    link.appendChild(remove);

    var body = document.createElement('div');
    body.className = 'card__body';

    var title = document.createElement('a');
    title.href = product.url;
    title.className = 'card__title';
    title.textContent = product.title;

    var price = document.createElement('div');
    price.className = 'card__price price';
    price.textContent = formatPrice(product.price);

    body.appendChild(title);
    body.appendChild(price);

    element.appendChild(link);
    element.appendChild(body);
    return element;
  }

  function render() {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page || !window.DienteWishlist) return;

    var grid = page.querySelector('[data-wishlist-grid]');
    var empty = page.querySelector('[data-wishlist-empty]');
    if (!grid) return;

    var handles = window.DienteWishlist.read();
    grid.textContent = '';

    if (!handles.length) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    Promise.all(
      handles.map(function (handle) {
        return fetch(productUrl(handle))
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      products.filter(Boolean).forEach(function (product) {
        grid.appendChild(card(product));
      });
      if (!grid.children.length && empty) empty.hidden = false;
      document.dispatchEvent(new CustomEvent('wishlist:render'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
  document.addEventListener('wishlist:updated', render);
})();